<template>
    <div>
        <b-form-checkbox
            v-model="check"
            switch
            @change="change">
        </b-form-checkbox>
    </div>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-group-pair-add-student-add-input-component',
    props: ['user', 'groupId'],
    watch: {
        user: function (user) {
            this.check = !!user.group_pair_students.length;
        },
    },
    data() {
        return {
            check: !!this.user.group_pair_students.length,
        };
    },
    methods: {
        change(value) {
            if (value) {
                const data = {
                    group_id: this.groupId,
                    user_id: this.user.id,
                };

                this.axios.post(this.routes.groupPairStudentAdd(), data).then(
                    (response) => {
                        this.user.addRelation('group_pair_students', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else if (this.user.group_pair_students.length) {
                this.axios.delete(this.routes.groupPairStudentDelete(this.user.group_pair_students[0].id)).then(
                    (response) => {
                        // ords.hold();
                        //
                        // this.user.detach('group_pair_students', this.user.group_pair_students[0].id);
                        this.user.group_pair_students[0].remove();

                        // ords.continue();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
